RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    const messageProgression = [
        'dummyMessage',
        {
            delayMs: 7000,
            messageText: 'Still loading...'
        },
        {
            delayMs: 8000,
            messageText: 'Just finishing up...'
        },
        {
            delayMs: 5000,
            messageText: 'Almost there...'
        }
    ];

    views.DiscoveryLoadingView = RivalIQ.views.BlockLoading.extend({
        className: 'panel-loading in discovery-loading',

        showMessage: function (messageText) {
            const me = this;

            me.ui.message.text(messageText);
            me.ui.message.addClass('in');
            me.$el.addClass('message-in');
        },

        _scheduleMessage: function (messageIdx) {
            const me = this;

            let currentMessage = _.get(messageProgression, [messageIdx]);

            if (messageIdx === 0) {
                // this needs to be here so we properly update the channel when it changes
                const channelKey = _.includes(window.location.pathname, RivalIQ.enums.channels.INSTAGRAM) ? RivalIQ.enums.channels.INSTAGRAM : RivalIQ.enums.channels.TWITTER;
                const channel = RivalIQ.data.channels.get(channelKey);

                let messageText = `Loading ${_.upperFirst(channel.get('name'))} ${channel.get('postName')}s...`;
                if (channelKey === RivalIQ.enums.channels.TWITTER) {
                    messageText = `Loading ${channel.get('postName')}s...`;
                }
                currentMessage = {
                    delayMs: 2000,
                    messageText: messageText
                };
            }

            if (currentMessage) {
                me.timeout = setTimeout(function () {
                    if (me.isDestroyed) {
                        return;
                    }

                    me.showMessage(currentMessage.messageText);
                    me._scheduleMessage(messageIdx + 1);
                }, currentMessage.delayMs);
            }
        },

        showForView: function () {
            const me = this;
            me.clearMessage();
            Marionette.Dashboard.views.BlockLoading.prototype.showForView.apply(me, arguments);

            me._scheduleMessage(0);
        }
    });
});
